export { default as DocumentTemplatesMspa } from "./DocumentTemplatesMspa";